import { render, staticRenderFns } from "./RomaneioTable.vue?vue&type=template&id=61123f46"
import script from "./RomaneioTable.vue?vue&type=script&lang=js"
export * from "./RomaneioTable.vue?vue&type=script&lang=js"
import style0 from "./RomaneioTable.vue?vue&type=style&index=0&id=61123f46&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61123f46')) {
      api.createRecord('61123f46', component.options)
    } else {
      api.reload('61123f46', component.options)
    }
    module.hot.accept("./RomaneioTable.vue?vue&type=template&id=61123f46", function () {
      api.rerender('61123f46', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/flow/customReports/components/tables/RomaneioTable.vue"
export default component.exports